import { render, staticRenderFns } from "./CommercialListTable.vue?vue&type=template&id=06e33c25&scoped=true&lang=html&"
import script from "./CommercialListTable.vue?vue&type=script&lang=js&"
export * from "./CommercialListTable.vue?vue&type=script&lang=js&"
import style0 from "./CommercialListTable.vue?vue&type=style&index=0&id=06e33c25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e33c25",
  null
  
)

export default component.exports